export enum LockStage {
  AUTOCHARGE,
  PARTNER,
  UPDATE_AUTOCHARGE,
  UPDATE_PROFILE_ID,
  UPDATE_ADMIN,
  UPDATE_OWNER,
  UPDATE_DISCOUNT_DIVISOR,
  UPDATE_PENALTY_DIVISOR,
  UPDATE_PARAMETERS,
  WITHDRAW,
  DELETE_PROTOCOL,
  UPDATE_FREE_TRIAL,
  DELETE,
  CONFIRM_DELETE,
  CONFIRM_UPDATE_FREE_TRIAL,
  CONFIRM_PARTNER,
  CONFIRM_AUTOCHARGE,
  CONFIRM_UPDATE_AUTOCHARGE,
  CONFIRM_UPDATE_PROFILE_ID,
  CONFIRM_UPDATE_ADMIN,
  CONFIRM_UPDATE_OWNER,
  CONFIRM_UPDATE_DISCOUNT_DIVISOR,
  CONFIRM_UPDATE_PENALTY_DIVISOR,
  CONFIRM_UPDATE_PARAMETERS,
  CONFIRM_WITHDRAW,
  CONFIRM_DELETE_PROTOCOL,
  SETTINGS,
  ADMIN_SETTINGS,
  TX_CONFIRMED,
}
